import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { Endpoints } from "../constants/endpoint.constant";
import { httpClient } from "../api/httpClient";
import { db } from "./firebaseApp";

export async function getUserProfile(uid) {
  if (!uid) return null;
  const ref = doc(db, "users", uid);
  const snapshot = await getDoc(ref);
  if (!snapshot.exists()) return null;
  return { id: uid, ...snapshot.data() };
}

export async function getAuthenticatedUserProfile(uid) {
  if (!uid) return null;

  try {
    const response = await httpClient.get(Endpoints.GET_USER(uid));
    return response?.data?.success ? response.data.data : null;
  } catch (error) {
    return getUserProfile(uid);
  }
}

export async function ensureUserProfile(uid, data) {
  if (!uid) return;
  const ref = doc(db, "users", uid);
  await setDoc(
    ref,
    {
      ...data,
      updatedAt: serverTimestamp(),
      createdAt: data?.createdAt ?? serverTimestamp(),
    },
    { merge: true }
  );
}
